import { create } from "zustand";

/**
 * View state for the routines page. Detail is now the editable page (no
 * separate read-only view), so `openEdit` is kept as an alias for callers
 * that still distinguish the intent.
 */

export type RoutineMode =
  | { kind: "list" }
  | { kind: "detail"; id: string }
  | { kind: "create" };

interface RoutineUiStore {
  mode: RoutineMode;
  openList: () => void;
  openDetail: (id: string) => void;
  openCreate: () => void;
  openEdit: (id: string) => void;
}

export const useRoutineUi = create<RoutineUiStore>((set) => ({
  mode: { kind: "list" },
  openList: () => set({ mode: { kind: "list" } }),
  openDetail: (id) => set({ mode: { kind: "detail", id } }),
  openCreate: () => set({ mode: { kind: "create" } }),
  openEdit: (id) => set({ mode: { kind: "detail", id } }),
}));
